// Actions contract row 7 (Mike, 2026-09-24, answer 8, "Go to what it names"): "Open the thread" and "Open what you
// sent" open the message inside Cobrain. The item page shows it here, above the evidence, when its address names the
// message (?signal=). The thread is read as the person may read it (GET /api/drafts/thread/:signalId): the earlier
// messages, oldest first, then the one the option named.
import { useEffect, useState } from 'react';
import { CardFrame } from '../parts/index.js';
import { ApiError } from '../api.js';
import { threadRead, type ThreadMessageView } from './api.js';
import { MessageView } from './MessageView.js';

type Load = { kind: 'loading' } | { kind: 'ready'; subject: string | null; messages: ThreadMessageView[] } | { kind: 'error'; said: string };

export function ThreadPanel({ store, signalId }: { store: string; signalId: string }) {
  const [state, setState] = useState<Load>({ kind: 'loading' });
  useEffect(() => {
    let live = true;
    setState({ kind: 'loading' });
    threadRead(store, signalId)
      .then((r) => { if (live) setState({ kind: 'ready', subject: r.thread.subject, messages: r.thread.messages }); })
      .catch((e: unknown) => { if (live) setState({ kind: 'error', said: e instanceof ApiError || e instanceof Error ? e.message : String(e) }); });
    return () => { live = false; };
  }, [store, signalId]);

  if (state.kind === 'loading') return <CardFrame variant="panel" className="evidence thread" aria-busy="true"><p className="note">Reading the message…</p></CardFrame>;
  if (state.kind === 'error') return <CardFrame variant="panel" className="evidence thread"><p className="note">Cobrain could not open the message: {state.said.replace(/\.$/, '')}.</p></CardFrame>;
  return (
    <CardFrame variant="panel" className="evidence thread" aria-label="the message">
      {state.subject ? <p className="gist"><strong>{state.subject}</strong></p> : null}
      {state.messages.map((m) => <MessageView key={m.id} message={m} named={m.id === signalId} showSubject={false} store={store} />)}
    </CardFrame>
  );
}
